const styles = theme => ({
  containerModified: {
    marginBottom: '0.875em',
    [theme.breakpoints.down('sm')]: {
      '& input, & p': {
        fontSize: '16px',
      },
    },
  },
  crossIconimg: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  PrevIcon: {
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
  containerPadding: {
    padding: '24px',
    [theme.breakpoints.down('xs')]: {
      padding: '16px',
    },
  },
  viewMoreWrapper: {
    borderBottom: 'none',
    padding: '10px 0px 0px',
  },
  modalCls: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      height: '100vh',
      width: '100vw',
      borderRadius: '0px',
      minHeight: '100vh',
    },
  },
  modalHeading: {
    fontWeight: '600',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    '& span': {
      [theme.breakpoints.down('xs')]: {
        marginLeft: '1em',
      },
    },
  },
  titleHead: {
    [theme.breakpoints.down('sm')]: {
      padding: '20px 1em',
    },
  },
  ListHeading: {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '150%',
    margin: '0px 0px 16px !important',
  },
  addActionBtn: {
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'none',
    padding: '16px 40px',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      padding: '16px 24px',
      width: '100%',
    },
    '& img': {
      marginRight: '0.5em',
    },
  },
  itemActions: {
    display: 'flex',
    flexDirection: 'row !important',
    justifyContent: 'flex-end',
    textAlign: 'right',
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px !important',
      justifyContent: 'flex-start',
      padding: '0px 36px',
    },
    '& button': {
      color: theme.palette.primary.main,
      textTransform: 'capitalize',
      margin: '0 0px',
      '&:hover': {
        background: 'none',
      },
    },
  },
  index: {
    width: '40px',
    height: '32px',
    display: 'block',
    lineHeight: '32px',
    fontWeight: 600,
    textAlign: 'center',
    backgroundColor: '#EBEEF3',
    borderRadius: '5px',
    maxWidth: '32px',
  },
  actionsBtnContainer: {
    margin: '1em 0',
    gridTemplateAreas: '"1 1"',
    '& button': {
      borderRadius: '4px',
      textTransform: 'capitalize',
      fontWeight: 600,
      fontSize: '16px',
      padding: '16px 40px',
      width: '100%',
      whiteSpace: 'nowrap',
      borderColor: theme.palette.primary.adgmBlack,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 'auto',
      marginBottom: '-12px',
      boxShadow: '1px -10px 13px rgba(0, 0, 0, 0.1)',
      padding: '10px 15px 0px 15px',
      marginRight: '-24px',
      marginLeft: '-24px',
    },
  },
  adgmRedBtn: {
    background: theme.palette.primary.main,
  },
  modalContainerModified: {
    padding: '16px 0px !important',
    '& p': {
      marginBottom: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      '& input, & p': {
        fontSize: '16px',
      },
    },
  },
  itemContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  contentCls: {
    [theme.breakpoints.down('sm')]: {
      borderBottom: '1px solid #EBEEF3',
      paddingBottom: '10px',
    },
  },
  dividerImg: {
    marginTop: '5px',
  },
  item: {
    padding: '12px',
    border: 'solid 1px #CED1D6',
    gap: '16px',
    borderRadius: '5px',
    marginBottom: '15px',
    '& p': {
      width: '100%',
      fontWeight: 500,
      fontSize: '1em',
      margin: 0,
      lineHeight: '1.5em',
    },
    '& div': {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '10px',
      alignItems: 'flex-start',
      '& div:last-of-type': {},
      '& span': {
        cursor: 'pointer',
        transition: 'ease-in-out 0.3s',
        whiteSpace: 'nowrap',
        '&:hover': {
          transition: 'ease-in-out 0.3s',
        },
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      display: 'flex',
      flexWrap: 'wrap',
      '& p': {
        width: '100%',
      },
    },
  },
  grayBox: {
    backgroundColor: theme.palette.primary.grey,
    marginLeft: '-24px',
    marginRight: '-24px',
    padding: '12px',
    marginTop: '10px',
    rowGap: '20px',
    flexDirection: 'column',
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
    },
  },
  gratTextColor: {
    color: '#8C9099',
  },
  fontWeight600: {
    fontWeight: '600',
    fontSize: '14px',
  },
  copyRightEvent: {
    marginLeft: '10px',
  },
  modalTitleText: {
    fontSize: '1.1rem',
    fontWeight: '900',
  },
  redStar: {
    color: 'red',
    fontSize: '24px',
    fontWeight: '800',
  },
  responsiveAddActionBtn: {
    padding: '10px 24px',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'none',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    '& img': {
      marginRight: '0.5em',
    },
  },
});
export default styles;
